var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "laptop-code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.8788 40.7062C32.66 41.4875 33.9263 41.4875 34.7075 40.7062L36.1213 39.2925C36.9025 38.5112 36.9025 37.245 36.1213 36.4638L31.6562 32L36.12 27.535C36.9012 26.7538 36.9012 25.4875 36.12 24.7063L34.7062 23.2925C33.925 22.5112 32.6587 22.5112 31.8775 23.2925L24.585 30.585C23.8037 31.3662 23.8037 32.6325 24.585 33.4137L31.8788 40.7062ZM43.88 39.2938L45.2938 40.7075C46.075 41.4888 47.3413 41.4888 48.1225 40.7075L55.415 33.415C56.1963 32.6338 56.1963 31.3675 55.415 30.5863L48.1225 23.2937C47.3413 22.5125 46.075 22.5125 45.2938 23.2937L43.88 24.7075C43.0988 25.4888 43.0988 26.755 43.88 27.5362L48.3438 32L43.88 36.465C43.0988 37.2463 43.0988 38.5125 43.88 39.2938ZM78 60H47.6925C47.6 62.4762 45.8538 64 43.6 64H36C33.6637 64 31.8725 61.8162 31.9038 60H2C0.9 60 0 60.9 0 62V64C0 68.4 3.6 72 8 72H72C76.4 72 80 68.4 80 64V62C80 60.9 79.1 60 78 60ZM72 14C72 10.7 69.3 8 66 8H14C10.7 8 8 10.7 8 14V56H72V14ZM64 48H16V16H64V48Z",
    fill: "#F86F03"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopCode);
export default __webpack_public_path__ + "static/media/laptop-code.7c237fafff14a8daaf0c232f15a3042b.svg";
export { ForwardRef as ReactComponent };